'use client'

import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'
import { InfoCircle } from 'solar-icons'
import { cn } from '@/lib/utils'

import { KeyChip, ShortcutType } from '@/components/ui/key-chip'

const hintVariants = cva('text-sm flex items-center gap-2', {
  variants: {
    variant: {
      default: 'text-gray-600',
      info: 'text-gray-600',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

const Hint = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof hintVariants> & {
      shortcut?: ShortcutType
    }
>(({ className, children, variant, shortcut, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(hintVariants({ variant }), className)}
    {...props}
  >
    {variant === 'info' && (
      <InfoCircle className="size-4 shrink-0" strokeWidth={1.5} />
    )}
    {children}
    {shortcut && <KeyChip shortcut={shortcut} />}
  </LabelPrimitive.Root>
))
Hint.displayName = LabelPrimitive.Root.displayName

export { Hint }
